import React from 'react';

const AboutUs: React.FC = () => {
  return (
    <section className="bg-white py-8">
      <div className="max-w-6xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900">
            Om oss
          </h2>
        </div>

        {/* Main Content - Image Left, Text Right */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          {/* Image Section */}
          <div className="order-2 lg:order-1">
            <div className="relative rounded-xl overflow-hidden shadow-lg w-full h-fit">
              <img 
                src="/images/Computer Ukraine Sweden flag.jpg" 
                alt="Computer med Ukraina och Sverige flaggor" 
                className="w-full h-auto lg:h-[320px] object-cover"
              />
            </div>
          </div>

          {/* Text Content */}
          <div className="order-1 lg:order-2">
            <div className="text-gray-800 text-base leading-6 text-justify space-y-4">
              <p>
                UtvecklareDirekt är en svensk konsultförmedlare av ukrainska utvecklare per timme. Vi riktar oss till företag med egen utveckling som behöver resurser. Vi säljer inte projekt. Varför Ukraina? Idag, 2025, finns tillgängliga utvecklare som söker uppdrag. Vi kopplar samman denna kompetens med svenska företag.
              </p>

              <p>
                När kriget började februari 2022 fortsatte Ukrainas leveranser av IT-projekt som vanligt till väst. Nu under konfliktens fjärde år har många av IT-projekten levererats klart och har tyvärr inte ersatts av nya i samma takt.
              </p>

              <p>
                Därför finns UtvecklareDirekt. Detta är vårt sätt att göra något bra. Vi som är bakom bolaget startade vårt första kontor i Ukraina 2009 och har sedan dess haft över 400 lokalt anställda i olika företag.
              </p>
              
              {/* Callout box */}
              <div className="bg-gradient-to-r from-blue-50 to-yellow-50 border-l-4 border-primary-500 pl-3 py-2 rounded-r-lg">
                <span className="text-gray-900 font-medium">
                  Utveckla direkt, att ni stödjer Ukraina ekonomiskt får ni på köpet.
                </span>
              </div>
              
              {/* Founder signature */}
              <p className="text-sm text-gray-600 text-right font-medium">
                Elin Mårdfelt @utvecklaredirekt.se<br />
                Grundare
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs; 